// import React from 'react'
import { Link } from 'gatsby'
// import AniLink from 'gatsby-plugin-transition-link/AniLink'

// const Link = (props) => (
//   <AniLink paintDrip duration={.5} hex='var(--color-secondary)' {...props} />
// )

export default Link